function StatsSection() {
  const { stats } = window.AppData.siteContent;

  return (
    <section className="mt-6 grid gap-4 rounded-3xl border border-white/80 bg-white/75 p-4 shadow-glow backdrop-blur-xl sm:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat) => (
        <div key={stat.label} className="p-3 text-center">
          <strong className="block font-display text-3xl font-bold">{stat.value}</strong>
          <span className="text-sm font-semibold text-slate-500">{stat.label}</span>
        </div>
      ))}
    </section>
  );
}

window.AppSections = window.AppSections || {};
window.AppSections.StatsSection = StatsSection;
